import React from 'react';
import { PhoneIcon, MailIcon } from 'lucide-react';
export function Logo() {
  return <div className="flex items-center justify-between w-full" data-id="element-927">
      <div className="flex items-center" data-id="element-928">
        <img src="https://cdn.magicpatterns.com/uploads/jAaJbUwB1t1dUCrFYJwyZT/Unknown_9.jpg" alt="TrueScore & USA TKD" className="h-20 w-auto" data-id="element-929" />
      </div>
      <div className="hidden md:flex flex-col items-end text-slate-700" data-id="element-930">
        <div className="flex items-center mb-1" data-id="element-931">
          <PhoneIcon size={16} className="mr-2 text-red-600" data-id="element-932" />
          <span className="text-sm font-medium" data-id="element-933">(517) 294-0315</span>
        </div>
        <div className="flex items-center" data-id="element-934">
          <MailIcon size={16} className="mr-2 text-red-600" data-id="element-935" />
          <span className="text-sm font-medium" data-id="element-936">shane@tkdscore.com</span>
        </div>
      </div>
    </div>;
}